import {create} from 'zustand'

type CurrentCourseIdState = {currentCourseId: number | null}

const initialCurrentCourseIdState: CurrentCourseIdState = {currentCourseId: null}

type Actions = {
  changeCurrentCourseId: (courseId: number) => void
}

const useStore = create<CurrentCourseIdState & Actions>()(set => ({
  ...initialCurrentCourseIdState,
  changeCurrentCourseId: (courseId: number) => set(() => ({currentCourseId: courseId})),
}))

export function resetCurrentCourseIdStore(): void {
  useStore.setState(initialCurrentCourseIdState)
}

export const useCurrentCourseIdStore = (): {
  changeCurrentCourseId: (courseId: number) => void
  currentCourseId: number | null
} => {
  const {changeCurrentCourseId, currentCourseId} = useStore()

  return {
    changeCurrentCourseId,
    currentCourseId,
  }
}
